import { priorityColors } from "../data/constants";
export function setPriorityMap(store, priorities) {
    const priorityMap = {};
    for (let index = 0; index < priorities.length; index++) {
        const item = priorities[index];
        priorityMap[item.id] = {
            ...item,
            color: item.color || priorityColors[index % priorityColors.length],
        };
    }
    store.setState({ priorityMap });
}
//# sourceMappingURL=priority.js.map